<template>
	<div class="add-form">
		<Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
			<div class="tag-title">文字方式</div>

			<FormItem label="展示文字" prop="title">
				<Input v-model="form.title" placeholder="请输入展示文字" style="width: 440px"></Input>
			</FormItem>
			<FormItem label="联系电话" prop="mobile">
				<Input v-model="form.mobile" placeholder="请输入联系电话" style="width: 440px"></Input>
			</FormItem>
			<FormItem label="跳转地址" prop="link">
				<Input v-model="form.link" placeholder="请输入跳转地址" style="width: 440px"></Input>
			</FormItem>

			<div class="tag-title">图片方式</div>

			<FormItem label="展开小图" prop="show_image">
				<upload-file-one
					:defaultUrl="form.show_image"
					type="img"
					tips="默认30 * 30"
					@on-change="fileChange($event, 'show_image')"
				></upload-file-one>
			</FormItem>
			<FormItem label="展开大图" prop="big_image">
				<upload-file-one
					:defaultUrl="form.big_image"
					type="img"
					tips="默认100 * 100"
					@on-change="fileChange($event, 'big_image')"
				></upload-file-one>
			</FormItem>
		</Form>
		<Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
	</div>
</template>

<script>
	import uploadFileOne from '@/components/upload-custom/upload-file-one'
	import { apiGetSystem, apiSetSystem } from '@/api/system'

	export default {
		name: 'add-form',
		components: {
			uploadFileOne,
		},
		data() {
			return {
				query: {},
				search: {},
				diyDom: {},
				// 表单数据
				form: {
					title: '',
					mobile: '',
					link: '',
					show_image: '',
					big_image: '',
				},
				diyData: {
					rules: {
						title: [{ required: true, message: '展示文字不能为空', trigger: 'blur' }],
						mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
						link: [{ required: true, message: '跳转地址不能为空', trigger: 'blur' }],
						show_image: [{ required: true, message: '展示小图不能为空', trigger: 'change' }],
						big_image: [{ required: true, message: '展示大图不能为空', trigger: 'change' }],
					},
				},
				apiData: {},
			}
		},
		computed: {},
		methods: {
			// 获取配置
			getSettings() {
				this.$store.commit('setSpinShow', true)
				apiGetSystem('technical_support')
					.then(res => {
						this.form = { ...res }
					})
					.finally(() => this.$store.commit('setSpinShow', false))
			},

			// 获取上传的图片
			fileChange(e, type) {
				if (type == 'show_image') {
					this.form.show_image = e
				} else if (type == 'big_image') {
					this.form.big_image = e
				}
			},
			submit() {
				this.$refs['addForm'].validate(valid => {
					if (valid) {
						apiSetSystem('technical_support', {
							technical_support: this.form,
						}).then(() => {
							this.$Message.success('保存成功')
							this.getSettings()
						})
					}
				})
			},
		},
		mounted() {
			this.getSettings()
		},
	}
</script>

<style scoped lang="less">
	.add-form {
		border: 1px solid #ededed;
		margin: 0 20px;
		padding: 26px 20px;

		.title {
			font-size: 14px;
			font-weight: bold;
			color: #333333;
			line-height: 19px;
			margin-bottom: 10px;
		}
	}
</style>
